<!-- use tags -->

import Layout1 from "../../src/routes/_main-site/+layout.marko";
import Page from "../../src/routes/_main-site/contact/+page.marko";

<Layout1>
	<Page/>
</>
